import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ToolItemsApi,
  ToolDataModuleDataContractsClassificationType,
  ToolDataModuleDataContractsToolItemDto,
} from '@tfs/tool-library-data-api';

@Injectable({
  providedIn: 'root',
})
export class ToolComparisonDataService {
  private readonly toolItemsApi = inject(ToolItemsApi);

  loadItem(
    id: string,
    classificationType: ToolDataModuleDataContractsClassificationType = ToolDataModuleDataContractsClassificationType.ClassGroup
  ): Observable<ToolDataModuleDataContractsToolItemDto> {
    return this.toolItemsApi.getToolItemDetailsById(id, classificationType);
  }
}
